import React, { createRef, useContext, useState } from 'react'

import Backdrop from '@material-ui/core/Backdrop'
import Fade from '@material-ui/core/Fade'
import Modal from '@material-ui/core/Modal'
import { makeStyles } from '@material-ui/core/styles'

import PropTypes from 'prop-types'
import Context from '../../context'
import { createEventPlace } from '../../services/ClubeApi'

import AddressForm from '../AddressForm'
import ProgressBar from '../ProgressBar'

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',

    alignItems: 'center',
    justifyContent: 'center'
  },
  paper: {
    width: '80%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3)
  }
}))

function CreateEventPlaceModal({ updatePlacesList }) {
  const classes = useStyles()
  const exitButtonPlaces = createRef()
  const { formObject, setFormObject, setOpenToast, openPlaceModal, setOpenPlaceModal } =
    useContext(Context)
  const [isLoading, setIsLoading] = useState(false)
  const [latLong, setLatLong] = useState({
    lat: '',
    long: ''
  })

  const clearObjectForm = () => {
    setFormObject({
      ...formObject,
      placeName: '',
      name: '',
      zipcode: '',
      address: '',
      number: '',
      neighborhood: '',
      city: '',
      uf: '',
      complement: ''
    })
    setOpenPlaceModal(false)
  }

  const handleSaveButton = async () => {
    setIsLoading(true)
    const { placeName, zipcode, address, number, neighborhood, city, uf, complement } = formObject
    const placeToSave = {
      name: placeName,
      zipcode,
      address,
      number,
      neighborhood,
      city,
      uf,
      complement,
      latitude: latLong.lat,
      longitude: latLong.long
    }

    const r = await createEventPlace(placeToSave)
    if (r) {
      updatePlacesList()
      setFormObject({ ...formObject, place: r.id })
      setOpenToast({
        open: true,
        message: `Criado o Produtor ${formObject.placeName} com sucesso`,
        type: 'success'
      })
      setOpenPlaceModal(false)
    } else {
      setOpenToast({
        open: true,
        message: `Ocorreu algum erro ao criar a Produtora, favor tente mais tarde.`,
        type: 'error'
      })
    }

    setIsLoading(false)
  }

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={openPlaceModal}
      onClose={() => {
        setOpenPlaceModal(false)
      }}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
    >
      <Fade in={openPlaceModal}>
        <div className={classes.paper}>
          <div className="modal-content">
            {!isLoading ? (
              <>
                <div className="modal-header">
                  <h5 className="modal-title">Adicionar Local para Eventos</h5>
                </div>
                <div className="modal-body">
                  <div className="row">
                    <div className="form-group col-md-12">
                      <input
                        id="producerName"
                        type="text"
                        className="form-control"
                        placeholder="Nome do Local"
                        value={formObject.placeName}
                        onChange={e => {
                          setFormObject({
                            ...formObject,
                            placeName: e.target.value
                          })
                        }}
                      />
                    </div>
                    <Context.Provider
                      value={{
                        latLong,
                        formObject,
                        setFormObject,
                        setLatLong
                      }}
                    >
                      <div className="form-group col-md-12">
                        <AddressForm title="Local" />
                      </div>
                    </Context.Provider>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    ref={exitButtonPlaces}
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal"
                    onClick={clearObjectForm}
                  >
                    Cancelar
                  </button>
                  <button
                    disabled={formObject.placeName && formObject.placeName.length < 1}
                    type="button"
                    className="btn btn-primary"
                    onClick={handleSaveButton}
                  >
                    Salvar
                  </button>
                </div>
              </>
            ) : (
              <ProgressBar height="20px" marginBottom="10px" marginTop="10px" width="100%" />
            )}
          </div>
        </div>
      </Fade>
    </Modal>
  )
}

CreateEventPlaceModal.propTypes = {
  updatePlacesList: PropTypes.func.isRequired
}

export default CreateEventPlaceModal
